import React from 'react';

import { tableBorderSizes } from '@aline/common';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import { TableBorderWeightIcon } from 'src/components/icons/TableBorderWeightIcon';
import { makeStyles } from 'tss-react/mui';

import { FormikOptionsSelect } from './FormikOptionsSelect';
import { useInputStyles } from './useInputStyles';

const useStyles = makeStyles()(theme => ({
  icon: {
    flex: '0 0 auto',
  },
  input: {
    flex: '1 0 auto',
  },
  inputBox: {
    '&:focus-within': {
      border: 'none',
    },
    border: 'none',
    width: 120,
  },
  inputContent: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  selectRoot: {
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)', // MUI's default border color
    },
  },
}));

interface FormikBorderSelectProps {
  fieldName: string;
}

/**
 * Extends FormikOptionsSelect to provide a select component for selecting
 * border sizes.
 */
export function FormikBorderSelect({ fieldName }: FormikBorderSelectProps): JSX.Element {
  const { classes } = useStyles();
  const { classes: inputClasses } = useInputStyles({});
  return (
    <FormikOptionsSelect
      className={classes.inputBox}
      fieldName={fieldName}
      options={tableBorderSizes.map(weight => ({ label: `${weight} pt`, value: `${weight}` }))}
      renderValue={label => {
        return (
          <div className={classes.inputContent}>
            <TableBorderWeightIcon className={classes.icon} />
            <Typography className={clsx(inputClasses.inputText, classes.input)}>{label}</Typography>
          </div>
        );
      }}
      selectClasses={{ root: classes.selectRoot }}
    />
  );
}
